<gl-base-modal (closeModal)="close()">
  <p class="content" [innerHTML]="'popup_data_import_new_goodloading' | translate"></p>
</gl-base-modal>
